"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutBoxIteratorMainSubDocument = void 0;
var tslib_1 = require("tslib");
var list_1 = require("@devexpress/utils/lib/utils/list");
var document_layout_details_level_1 = require("../../layout/document-layout-details-level");
var layout_position_creator_1 = require("../layout-position-creator");
var layout_box_iterator_base_1 = require("./layout-box-iterator-base");
var backward_helper_1 = require("./layout-position-advance-helpers/backward-helper");
var forward_helper_1 = require("./layout-position-advance-helpers/forward-helper");
var LayoutBoxIteratorMainSubDocument = (function (_super) {
    tslib_1.__extends(LayoutBoxIteratorMainSubDocument, _super);
    function LayoutBoxIteratorMainSubDocument(subDocument, layout, intervalStart, intervalEnd) {
        return _super.call(this, subDocument, layout, intervalStart, intervalEnd) || this;
    }
    LayoutBoxIteratorMainSubDocument.prototype.isInitialized = function () {
        if (!this.layout.isFullyFormatted) {
            var lastValidPage = this.layout.getLastValidPage();
            if (!lastValidPage || this.intervalEnd > list_1.ListUtils.last(lastValidPage.getContentIntervals()).end)
                return false;
        }
        return true;
    };
    LayoutBoxIteratorMainSubDocument.prototype.getNewLayoutPosition = function (position, endRowConflictFlags, middleRowConflictFlags) {
        return new layout_position_creator_1.LayoutPositionMainSubDocumentCreator(this.layout, this.subDocument, position, document_layout_details_level_1.DocumentLayoutDetailsLevel.Character)
            .create(endRowConflictFlags, middleRowConflictFlags);
    };
    LayoutBoxIteratorMainSubDocument.prototype.advancePosition = function () {
        return new forward_helper_1.LayoutPositionAdvanceForwardHelper(this.position, this.layout).advance();
    };
    LayoutBoxIteratorMainSubDocument.prototype.advancePositionBack = function () {
        return new backward_helper_1.LayoutPositionAdvanceBackwardHelper(this.position, this.layout).advance();
    };
    return LayoutBoxIteratorMainSubDocument;
}(layout_box_iterator_base_1.LayoutBoxIteratorBase));
exports.LayoutBoxIteratorMainSubDocument = LayoutBoxIteratorMainSubDocument;
